






























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BackTop extends Vue {
  @Prop({ default: 0.1 }) private speed!: number;
}
